var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      _c("actionBarComponent", {
        attrs: {
          title: _vm.$t("__.Crud.janelaColeta.edit_vue_html.janelaColetaEdit"),
        },
        on: { onSave: _vm.save },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save()
            },
          },
        },
        [
          _c("fieldset", [
            _c(
              "div",
              { attrs: { slot: "rows" }, slot: "rows" },
              _vm._l(_vm.models, function (model, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "row list-inputs-container" },
                  [
                    _c("div", { staticClass: "col-sm-3 list-inputs-column" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("descricao" + index),
                              expression: "errors.first('descricao' + index)",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          index == 0
                            ? _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "descricao" + index,
                                    title: _vm.$t("__.obrigatorio"),
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.janelaColeta.edit_vue_html.descricao"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: model.descricao,
                                expression: "model.descricao",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "descricao" + index,
                              name: "descricao" + index,
                              autocomplete: "off",
                            },
                            domProps: { value: model.descricao },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  model,
                                  "descricao",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-4 list-inputs-column" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("localEntregaId" + index),
                              expression:
                                "errors.first('localEntregaId' + index)",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          index == 0
                            ? _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "localEntregaId" + index,
                                    title: _vm.$t("__.obrigatorio"),
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.janelaColeta.edit_vue_html.localEntrega"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("comboComponent", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              id: "localEntregaId" + index,
                              name: "localEntregaId" + index,
                              data: _vm.locaisEntregaOptions,
                            },
                            model: {
                              value: model.localEntregaId,
                              callback: function ($$v) {
                                _vm.$set(model, "localEntregaId", $$v)
                              },
                              expression: "model.localEntregaId",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-2 list-inputs-column" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("horarioLimite" + index),
                              expression:
                                "errors.first('horarioLimite' + index)",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          index == 0
                            ? _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: {
                                    for: "horarioLimite" + index,
                                    title: _vm.$t("__.obrigatorio"),
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Crud.janelaColeta.edit_vue_html.horarioLimite"
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: model.horarioLimiteString,
                                expression: "model.horarioLimiteString",
                              },
                              { name: "mask-hora", rawName: "v-mask-hora" },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|hora",
                                expression: "'required|hora'",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "horarioLimite" + index,
                              name: "horarioLimite" + index,
                            },
                            domProps: { value: model.horarioLimiteString },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  model,
                                  "horarioLimiteString",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-3 list-inputs-column" }, [
                      _c("div", { staticClass: "form-group" }, [
                        index == 0
                          ? _c("label", { staticClass: "control-label" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("__.Crud.listInputs.acao")) +
                                  "\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [
                          _vm.models.length > 1
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    title: _vm.$t("__.Crud.listInputs.remover"),
                                    href: "#",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.onRemove(model)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-times button-remove",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          index == _vm.models.length - 1
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "__.Crud.listInputs.adicionar"
                                    ),
                                    href: "#",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onAdd($event)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-plus button-plus",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]
                )
              })
            ),
          ]),
          _vm._v(" "),
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c("div", { staticClass: "form-group newbtn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "submit" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-save",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.salvar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.cancel()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.voltar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }